import { config } from '../../../utils/config';
const { BASE_URL_Insights } = config;

export const tagServiceAPI = {
  get: `${BASE_URL_Insights}/Tags/GetAdminTags`,
  post: `${BASE_URL_Insights}/Tags`,
  put: `${BASE_URL_Insights}/Tags`,
  delete: (id) => `${BASE_URL_Insights}/Tags/${id}`,
  mergeTag: `${BASE_URL_Insights}/Tags/mergeTag`,
};

export const surveyTagServiceAPI = {
  get: `${BASE_URL_Insights}/surveyTag?id=0&customerType=0`,
  post: `${BASE_URL_Insights}/surveyTag`,
  put: `${BASE_URL_Insights}/surveyTag`,
  delete: (id) => `${BASE_URL_Insights}/surveyTag?id=${id}`,
};

export const questionServiceAPI = {
  getQuestionsByTagId: (tagId) =>
    `${BASE_URL_Insights}/questions/GetQuestionsForAdminByTagId?tagId=${tagId}`,
  delete: (id) => `${BASE_URL_Insights}/questions?id=${id}`,
  post: () => `${BASE_URL_Insights}/questions`,
  getAll: () => `${BASE_URL_Insights}/questions/getAll`,
  addUpdateQuestionForSuperAdmin: () =>
    `${BASE_URL_Insights}/questions/AddUpdateQuestionForSuperAdmin`,
};

export const surveyTemplateServiceAPI = {
  get: `${BASE_URL_Insights}/SurveyTemplates?id=0&customerType=0`,
  addUpdate: (id, n, audience, tags, ischeckIn) => {
    let url = `${BASE_URL_Insights}/SurveyTemplates/AddUpdateTemplate?id=${id}&name=${n}&audience=${audience}&ischeckIn=${ischeckIn}`;
    tags.map((tag, id) => {
      url += `&tags=${tag}`;
    });
    return url;
  },
  delete: (id) => `${BASE_URL_Insights}/SurveyTemplates/${id}`,
  getAllTemplatesForAdmin: () =>
    `${BASE_URL_Insights}/SurveyTemplates/GetAllTemplatesForAdmin`,
};

export const surveyTemplateQuestionsServiceAPI = {
  get: (id) =>
    `${BASE_URL_Insights}/SurveyQuestion/GetSurveyQuestionsBySurveyId?id=${id}`,
};

export const artifactApi = {
  get: (src) => `${BASE_URL_Insights}/Artifact/download?fileName=${src}`,
  post: () => `${BASE_URL_Insights}/Artifact`,
};

export const surveyQuestionApi = {
  post: () => `${BASE_URL_Insights}/surveyquestion`,
  addSurveyQuestionList: () =>
    `${BASE_URL_Insights}/surveyquestion/AddSurveyQuestionList`,
  put: () => `${BASE_URL_Insights}/surveyquestion`,
  delete: (id, surveyId) =>
    `${BASE_URL_Insights}/surveyquestion?id=${id}&&surveyId=${surveyId}`,
  get: (id) => `${BASE_URL_Insights}/surveyquestion?id=${id}`,
  getByToken: () =>
    `${BASE_URL_Insights}/surveyquestion/GetSurveyQuestionsBySurveyToken`,
  addSurveyQuestion: () =>
    `${BASE_URL_Insights}/surveyquestion/AddSurveyQuestion`,
  addSurveyQuestionRemoveTempId: (surveyId, replaceQdId, newQid) =>
    `${BASE_URL_Insights}/surveyquestion/AddSurveyQuestionRemoveTempId?surveyId=${surveyId}&replaceQdId=${replaceQdId}&newQid=${newQid}`,
  reorderSurveyQuestions: (f, t, fIdx, tIdx, surveyId) =>
    `${BASE_URL_Insights}/SurveyQuestion/ReorderSurveyQuestions?fromId=${f}&toId=${t}&fromIndex=${fIdx}&toIndex=${tIdx}&surveyId=${surveyId}`,
};
